<template>
    <div>
        <!-- 客户详情 -->
        <el-drawer title="客户详情" :visible.sync="drawer" :before-close="handleClose" :with-header="false" :wrapperClosable="true" :close-on-press-escape="false" size="95%">
            <div style="padding:20px;position:relative;color:#000;">
                <div style="margin-left:20px;">
                    <span :title="customerDel.nameCopy">
                        {{customerDel.nameCopy&&customerDel.nameCopy.length>8?customerDel.nameCopy.substring(0, 8):customerDel.nameCopy}}
                    </span>
                    <span v-if="userInfo.company_config&&userInfo.company_config.config_phone==1">
                        <el-button v-if="callStatus&&userInfo.trList.cno && customerType==1" @click="outcall()" type="primary" size="mini">呼叫</el-button>
                        <el-button v-if="callLoadingStatus&&userInfo.trList.cno && customerType==1" type="text">通话中</el-button>
                        <el-input v-if="!callStatus&&userInfo.trList.cno && customerType==1" v-model="fenjiCall" placeholder="分机号" type="text" size="mini" style="width:80px;"></el-input>
                        <el-button v-if="!callStatus&&userInfo.trList.cno && customerType==1" @click="clickFenji()" type="primary" size="mini">确定</el-button>
                        <el-button v-if="ringoffBtn&&userInfo.trList.cno && customerType==1" @click="unlink()" type="danger" size="mini">挂断</el-button>
                    </span>
                    <span v-if="userInfo.company_config&&userInfo.company_config.config_order==1">
                        <el-button v-if="customerType==1" @click="orderClick()" type="primary" size="mini">下单</el-button>
                    </span>
                </div>
                <div v-if="customerType==1" style="position:absolute;top:12px;left:440px;">
                    <el-input v-model="remarks" type="textarea" :rows="2" placeholder="请输入客户备注" style="width:360px;"></el-input>
                    <el-button @click="remarksClick()" type="primary" size="mini">提交</el-button>
                </div>
                <div @click="handleClose" class="drawer-close">
                    <i class="el-icon-close iconClass"></i>
                </div>
            </div>
            <div class="clearfix" style="width: 100%; height: calc(100% - 100px);padding:0 20px;color:#000;font-size:14px;">
                <!-- 左侧数据 -->
                <div style="width: calc(60% - 5px); float: left; height: 100%; overflow-y: auto;">
                    <!-- 客户基本信息 -->
                    <div class="cuscard">
                        <p style="border-left: 4px solid #0d6efd;padding-left: 10px;font-size:16px;color:#070F29;line-height:22px;position:relative;">
                            客户信息
                            <el-button @click="labelClick()" type="primary" style="position:absolute;right:0;top:0;" size="mini">
                                绑定标签
                            </el-button>
                        </p>
                        <div class="clearfix" style="color:#B5B7BF;width:100%;margin-top:10px;border-bottom:1px solid #DCDFE6;padding-bottom:10px;">
                            <span style="float: left;width:25%;">客户ID：
                                <span style="color:#0d6efd;">{{customerDel.id}}</span>
                            </span>
                            <span style="float: left;width:25%;text-align:center;">归属：
                                <span style="color:#0d6efd;">{{customerDel.admin_user}}</span>
                            </span>
                            <span style="float: left;width:25%;text-align:center;">今日通话：
                                <span style="color:#0d6efd;">{{callStatistics.dayCount}}</span>
                            </span>
                            <span style="float: right;width:25%;text-align:right;">本周通话：
                                <span style="color:#0d6efd;">{{callStatistics.weekCount}}</span>
                            </span>
                        </div>
                        <div>
                            <div style="margin-top:10px;">
                                <span class="label-style">电话:</span>
                                <span style="margin-right:10px;">{{customerDel.phoneCopy}}</span>
                                <i @click="showPhone()" :class="!customerDel.phoneChange?'iconfont icon-biyanjing':'iconfont icon-yanjing'" style="color:#0d6efd;cursor:pointer;margin-right:10px;"></i>
                                <i v-if="customerDel.phoneChange" @click="copyText(customerDel.phoneCopy)" class="iconfont icon-fuzhi" style="color:#0d6efd;cursor:pointer;margin-right:10px;"></i>
                                <span v-if="customerDel.customer_type==2">分机号:{{customerDel.extension_code}}</span>
                                <span v-if="customerDel.customer_type==2">虚拟号过期时间:{{customerDel.effective_date}}</span>
                                <!-- <span v-if="customerDel.customer_type==1&&userInfo.company_config&&userInfo.company_config.config_sms==1">
                                  <el-button @click="getsendShortMessage()" :disabled="getCodeBtnDisable" type="primary" size="mini">{{codeBtnWord}}</el-button>
                                  <span style="color: #0d6efd;">({{customerDel.smsTimes}}/{{customerDel.maxTimes}})</span>
                                </span> -->
                            </div>
                            <div class="clearfix" style="width:100%;margin-top:10px;">
                                <span style="float: left;width:33%;">
                                    <span class="label-style">姓名:</span>
                                    <span :title="customerDel.nameCopy">
                                        {{customerDel.nameCopy&&customerDel.nameCopy.length>8?customerDel.nameCopy.substring(0, 8):customerDel.nameCopy}}
                                    </span>
                                    <!-- <i @click="showName()" :class="!customerDel.nameChange?'iconfont icon-biyanjing':'iconfont icon-yanjing'" style="color:#0d6efd;cursor:pointer;"></i> -->
                                    <i v-if="customerDel.nameChange" @click="copyText(customerDel.nameCopy)" class="iconfont icon-fuzhi" style="color:#0d6efd;cursor:pointer;"></i>
                                </span>
                                <span style="float: left;width:33%;">
                                    <span class="label-style">性别:</span>
                                    <span>{{customerDel.gender==1?'男':customerDel.gender==2?'女':'未知'}}</span>
                                </span>
                                <span style="float: left;width:33%;">
                                    <span class="label-style">生日:</span>
                                    <span>{{customerDel.birthday}}</span>
                                </span>
                            </div>
                            <div class="clearfix" style="width:100%;margin-top:10px;">
                                <span style="float: left;width:33%;">
                                    <span class="label-style">地域:</span>
                                    <span>{{customerDel.province}}{{customerDel.city}}</span>
                                </span>
                                <span style="float: left;width:33%;">
                                    <span class="label-style">区县:</span>
                                    <span>{{customerDel.area}}</span>
                                </span>
                                <span style="float: left;width:33%;">
                                    <span class="label-style">来源:</span>
                                    <span>{{customerDel.origin}}</span>
                                </span>
                            </div>
                            <div class="clearfix" style="width:100%;margin-top:10px;">
                                <span style="float: left;color:#B5B7BF;margin-right:10px;">街道(小区):</span>
                                <span style="float: left;margin-right:10px;">{{customerDel.streetCopy}}</span>
                                <!-- <i @click="showStreet()" :class="!customerDel.streetChange?'iconfont icon-biyanjing':'iconfont icon-yanjing'" style="color:#0d6efd;cursor:pointer;"></i> -->
                            </div>
                            <div class="clearfix" style="width:100%;margin-top:10px;">
                                <span style="float: left;color:#B5B7BF;margin-right:10px;">最后一次流入公海的日期:</span>
                                <span style="float: left;">{{customerDel.sea_date}}</span>
                            </div>
                            <div class="clearfix" style="width:100%;margin-top:10px;">
                                <span style="float: left;color:#B5B7BF;margin-right:10px;">当前绑定用户的分配时间:</span>
                                <span style="float: left;">{{customerDel.bind_date}}</span>
                            </div>
                            <div v-if="customerDel.tagInfo" class="clearfix" style="width:100%;margin-top:10px;">
                                <span style="float: left;color:#B5B7BF;margin-right:10px;">标签:</span>
                                <span v-for="(item,index) in customerDelTagInfoShow" :key="index" class="tagStyle">{{item.name}}</span>
                                <span v-if="customerDel.tagInfo&&customerDel.tagInfo.length" @click="tagInfoMoreClick()" style="float:right;color:#0d6efd;font-size:14px;cursor:pointer;">更多标签</span>
                            </div>
                        </div>
                    </div>
                    <!-- 客户基本信息end -->
                    <!-- 原订单数据 -->
                    <div class="div-card" style="margin-top:10px;">
                        <el-card class="box-card drawerRight">
                            <div slot="header" class="clearfix">
                                <p style="border-left: 4px solid #0d6efd;padding-left: 10px;font-size:16px;color:#070F29;line-height:24px;margin-bottom:0px;position:relative;">
                                    原订单数据
                                </p>
                            </div>
                            <div class="orderStyle">
                                <el-table :data="orderTableData" :cell-style="{padding:'4px 0px'}" :row-style="{height:'38px'}" border style="width: 100%;">

                                    <el-table-column prop="oid" label="订单ID" min-width="90" fixed="left"></el-table-column>
                                    <el-table-column prop="consignee" label="收货人" min-width="90" fixed="left">
                                        <template v-if="scope.row.consigneeCopy" slot-scope="scope">
                                            <span>{{scope.row.consigneeCopy}}</span>
                                            <i @click="showNameOrderData(scope.row,1)" :class="!scope.row.changeConsignee?'iconfont icon-biyanjing':'iconfont icon-yanjing'" style="color:#0d6efd;cursor:pointer;"></i>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="mobile" label="收货人手机号" min-width="150">
                                        <template slot-scope="scope">
                                            <span>{{scope.row.mobileCopy}}</span>
                                            <i @click="showPhoneOrderData(scope.row,1)" :class="!scope.row.changeMobile?'iconfont icon-biyanjing':'iconfont icon-yanjing'" style="color:#0d6efd;cursor:pointer;"></i>
                                            <i v-if="scope.row.changeMobile" @click="copyText(scope.row.mobileCopy)" class="iconfont icon-fuzhi" style="color:#0d6efd;cursor:pointer;"></i>
                                            <p v-if="scope.row.customer_type==2">分机号:{{scope.row.extension_code}}</p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="type_detail" label="平台" min-width="70"></el-table-column>
                                    <!-- <el-table-column prop="buyerNick" label="购买人昵称(待弃用)" min-width="130"></el-table-column> -->
                                    <el-table-column prop="itemTitle" label="商品" min-width="300">
                                        <template slot-scope="scope">
                                            <div v-if="scope.row.order_to_goods.length">
                                                <div v-for="(item,index) in scope.row.order_to_goods" :key="index" :style="(index+1)==scope.row.order_to_goods.length?'':'border-bottom: 1px solid #ccc;padding-bottom:10px;'">
                                                    <div :style="index==0?'':'padding-top:10px;'">
                                                        <p style="margin-bottom:0;">商品：{{item.goods_desc}}</p>
                                                        <p style="margin-bottom:0;">规格：{{item.sku_desc}}</p>
                                                        <p style="margin-bottom:0;">数量：{{item.amount}}</p>
                                                        <p style="margin-bottom:0;">价格：{{item.price}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="scope.row.itemTitle">
                                                <p style="margin-bottom:0;">商品：{{scope.row.itemTitle}}</p>
                                                <p style="margin-bottom:0;">规格：{{scope.row.skuDesc}}</p>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column prop="num" label="购买数量(待弃用)" min-width="120"></el-table-column> -->
                                    <el-table-column prop="totalFee" label="订单金额" min-width="100"></el-table-column>
                                    <el-table-column prop="status" label="订单状态" min-width="90">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.status_enum==10" class="payE">{{scope.row.status}}</span>
                                            <span v-else-if="scope.row.status_enum==30" class="payS">{{scope.row.status}}</span>
                                            <span v-else-if="scope.row.status_enum==40" class="sendE">{{scope.row.status}}</span>
                                            <span v-else-if="scope.row.status_enum==50" class="sendS">{{scope.row.status}}</span>
                                            <span v-else-if="scope.row.status_enum==70" class="orderS">{{scope.row.status}}</span>
                                            <span v-else-if="scope.row.status_enum==80" class="orderE">{{scope.row.status}}</span>
                                            <span v-else class="">{{scope.row.status}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="sendCode" label="物流单号" min-width="140">
                                        <!-- <template slot-scope="scope" slot="header">
                                            <span>
                                            物流单号
                                            <el-tooltip :aa="scope" class="item" effect="dark" content="物流单号，查询物流进度的唯一凭证" placement="top-start">
                                                <i class="el-icon-question" style="color:#66B1FF; margin-left:4px;'"> </i>
                                            </el-tooltip>
                                            </span>
                                        </template> -->
                                        <template slot-scope="scope">
                                            <span @click="sendClick(scope.row.send_code)" style="color:#66B1FF;cursor:pointer;">{{scope.row.send_type?scope.row.send_type+'：':''}}{{scope.row.send_code}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="payTime" label="支付时间" :show-overflow-tooltip="true" min-width="110"></el-table-column>
                                    <el-table-column prop="source" label="来源" min-width="100"></el-table-column>
                                    <el-table-column prop="admin_name" label="归属人" min-width="100"></el-table-column>
                                </el-table>
                                <el-pagination @current-change="handleChangeOrder" :total="orderTabletotal" small layout="prev, pager, next"></el-pagination>
                            </div>
                        </el-card>
                    </div>
                    <!-- 原订单数据end -->
                    <!-- 购买记录 -->
                    <div class="div-card" style="margin-top:10px;">
                        <el-card class="box-card drawerRight">
                            <div slot="header" class="clearfix">
                                <p style="border-left: 4px solid #0d6efd;padding-left: 10px;font-size:16px;color:#070F29;line-height:24px;margin-bottom:0px;position:relative;">
                                    购买记录
                                </p>
                            </div>
                            <div class="orderStyle">
                                <el-table :data="tableData" :cell-style="{padding:'4px 0px'}" :row-style="{height:'38px'}" border style="width: 100%;">
                                    <el-table-column prop="oid" label="订单ID" min-width="90" fixed="left"></el-table-column>
                                    <el-table-column fixed="left" prop="order_goods" label="商品" min-width="300">
                                        <template slot-scope="scope">
                                            <div v-if="scope.row.itemType==1">
                                                <div v-for="(item,index) in scope.row.order_goods" :key="index" :style="(index+1)==scope.row.order_goods.length?'':'border-bottom: 1px solid #ccc;padding-bottom:10px;'">
                                                    <div :style="index==0?'':'padding-top:10px;'">
                                                        <!-- display: flex;justify-content: center;align-items: center; -->
                                                        <!-- <img style="width:100px;" :src="item.goods_url"/> -->
                                                        <div style="width:80%;margin-left: 10px;">
                                                            <p style="width:100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;margin-bottom:0;">
                                                            商品名称：{{item.goods_name}}
                                                            </p>
                                                            <p style="width:100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;margin-bottom:0;">
                                                            商品规格：{{item.goods_attr}}
                                                            </p>
                                                            <p style="width:100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;margin-bottom:0;">
                                                            售卖价格：{{item.price}}
                                                            </p>
                                                            <p style="width:100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;margin-bottom:0;">
                                                            购买数量：<span style="color:#0d6efd;">{{item.num}}</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="scope.row.itemType==2">
                                                <div v-for="(item,index) in scope.row.order_goods" :key="index" :style="(index+1)==scope.row.order_goods.length?'':'border-bottom: 1px solid #ccc;padding-bottom:10px;'">
                                                    <div :style="index==0?'':'padding-top:10px;'">
                                                        <!-- display: flex;justify-content: center;align-items: center; -->
                                                        <div style="width:80%;margin-left: 10px;">
                                                            <p style="width:100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;margin-bottom:0;">
                                                                套餐名称：{{item.package_name}}
                                                            </p>
                                                            <div>
                                                                套餐详情：
                                                                <p v-for="(detail,detailIndex) in item.goods_detail" :key="detailIndex" style="margin-left:10px;margin-bottom:0;">
                                                                    {{detail.goods_name}}
                                                                    规格：{{detail.goods_attr}}，数量：{{detail.num}}
                                                                </p>
                                                            </div>
                                                            <p style="width:100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;margin-bottom:0;">
                                                                <!-- 售卖价格：{{item.price}} -->
                                                                售卖价格：{{item.package_price}}
                                                            </p>
                                                            <p style="width:100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;margin-bottom:0;">
                                                                <!-- 购买数量：<span style="color:#0d6efd;">{{item.num}}</span> -->
                                                                购买数量：<span style="color:#0d6efd;">{{item.package_quantity}}</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="scope.row.gift_goods.length">
                                                <p style="color:#f56c6c;margin-top:4px;margin-bottom:0;">赠品：</p>
                                                <div v-for="(item,index) in scope.row.gift_goods" :key="index" :style="(index+1)==scope.row.gift_goods.length?'':'border-bottom: 1px solid #ccc;padding-bottom:4px;'">
                                                    <div :style="index==0?'':'padding-top:4px;'">
                                                        <div style="width:80%;margin-left: 10px;">
                                                            <p :title="item.goods_name" style="width:100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;margin-bottom: 0px;">
                                                                商品名称：{{item.goods_name}}
                                                                <span>数量：<span style="color:#0d6efd;">{{item.num}}</span></span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="num" label="购买数量" min-width="80"></el-table-column>
                                    <el-table-column prop="payFee" label="支付金额" min-width="100"></el-table-column>
                                    <el-table-column prop="discountFee" label="优惠金额" min-width="90"></el-table-column>
                                    <el-table-column prop="consignee" label="收货人" min-width="90">
                                        <template v-if="scope.row.consigneeCopy" slot-scope="scope">
                                            <span>{{scope.row.consigneeCopy}}</span>
                                            <i @click="showNameOrderData(scope.row,2)" :class="!scope.row.changeConsignee?'iconfont icon-biyanjing':'iconfont icon-yanjing'" style="color:#0d6efd;cursor:pointer;"></i>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="mobile" label="收货人手机号" min-width="150">
                                        <template slot-scope="scope">
                                            <span>{{scope.row.mobileCopy}}</span>
                                            <i @click="showPhoneOrderData(scope.row,2)" :class="!scope.row.changeMobile?'iconfont icon-biyanjing':'iconfont icon-yanjing'" style="color:#0d6efd;cursor:pointer;"></i>
                                            <i v-if="scope.row.changeMobile" @click="copyText(scope.row.mobileCopy)" class="iconfont icon-fuzhi" style="color:#0d6efd;cursor:pointer;"></i>
                                            <p v-if="scope.row.customer_type==2">分机号:{{scope.row.extension_code}}</p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="sf_sign_code" label="物流状态" min-width="100">
                                      <template slot-scope="scope">
                                        <span>{{scope.row.sf_sign_code == 1 ?'顺丰到付': scope.row.sf_sign_code == 2 ?'签收' : scope.row.sf_sign_code == 3 ? '拒绝' : ''}}</span>
                                      </template>
                                    </el-table-column>
                                    <el-table-column prop="admin_remark" label="备注" min-width="140"></el-table-column>
                                    <el-table-column prop="status" label="订单状态" min-width="90">
                                        <template slot-scope="scope">
                                            <span>{{scope.row.status_detail}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="payTime" label="支付时间" :show-overflow-tooltip="true" min-width="110"></el-table-column>
                                    <el-table-column prop="customer_disease_remark" label="客户症状" min-width="120"></el-table-column>
                                    <el-table-column prop="customer_age" label="年龄段" min-width="120"></el-table-column>
                                </el-table>
                                <el-pagination @current-change="handleCurrentChangeOrder" :total="ordertotal" small layout="prev, pager, next"></el-pagination>
                            </div>
                        </el-card>
                    </div>
                    <!-- 购买记录end -->
                </div>
                <!-- 左侧数据end -->
                <div style="width: calc(40% - 5px); float: right; height: 100%; overflow-y: auto;">
                    <!-- 销售记录 -->
                    <div class="div-card">
                        <el-card class="box-card drawerRight">
                            <div slot="header" class="clearfix">
                                <p style="border-left: 4px solid #0d6efd;padding-left: 10px;font-size:16px;color:#070F29;line-height:24px;margin-bottom:0px;position:relative;">
                                    销售记录
                                </p>
                            </div>
                            <!-- <div>
                                <el-form>
                                    <el-row>
                                        <el-col :span="8">
                                            <div class="grid-content bg-purple">
                                                <el-form-item style="margin-right:4px;">
                                                    <el-select v-model="searchform.status" clearable filterable placeholder="数据流转" size="mini" style="width:calc(100%)">
                                                        <el-option v-for="item in dataoptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </div>
                                        </el-col>
                                        <el-col :span="8">
                                            <div class="grid-content bg-purple">
                                                <el-form-item style="margin-right:4px;">
                                                    <el-select v-model="searchform.status" clearable filterable placeholder="工作表单" size="mini" style="width:calc(100%)">
                                                        <el-option v-for="item in workoptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </div>
                                        </el-col>
                                        <el-col :span="8">
                                            <div class="grid-content bg-purple">
                                                <el-form-item>
                                                    <el-select v-model="searchform.status" clearable filterable placeholder="通话" size="mini" style="width:calc(100%)">
                                                        <el-option v-for="item in calloptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </div> -->

                            <el-tabs v-model="sellType" @tab-click="sellTabClick">
                                <el-tab-pane label="沟通记录" name="1"></el-tab-pane>
                                <el-tab-pane label="系统" name="2"></el-tab-pane>
                            </el-tabs>
                            <div class="salesRecord" style="margin-top:10px;">
                                <el-timeline :reverse="reverse">
                                    <el-timeline-item v-for="(activity, index) in activities" :key="index" :timestamp="activity.timestamp" :hide-timestamp="true" placement="top">
                                    <el-card>
                                        <div class="clearfix" style="line-height:24px;">
                                            <h4 class="timeright left" style="font-size:14px;">
                                                {{activity.type}}
                                                <span v-if="activity.traffic_status!='无'">{{activity.traffic_status}}</span>
                                            </h4>
                                            <span class="timeright right">{{activity.created_at}}</span>
                                        </div>
                                        <p v-if="sellType==1&&activity.call_duration!=0" class="timeright" style="line-height:24px;margin-bottom:0px;color:#0d6efd;">
                                            <span>通话时长：{{activity.call_duration}}</span>
                                            <el-button @click="getRecording(activity,index)" type="text" style="color:#409eff;">查看录音</el-button>
                                        </p>
                                        <p v-if="activity.record_url" style="margin-bottom:0px;">
                                            <audio :src="activity.record_url" style="width:216px;height: 24px;" controls="controls" ref="audio">您的浏览器不支持</audio>
                                        </p>
                                        <p class="timeright" style="line-height:24px;margin-bottom:0px;color:#e6a23c;">{{activity.remarks}}</p>
                                        <p class="timeright" style="line-height:24px;margin-bottom:0px;color:#0d6efd;">
                                            <span v-for="(item,index) in activity.tags" :key="index" style="font-size:12px;border:1px solid #0d6efd;color:#0d6efd;padding:2px 10px;border-radius:12px;margin-right:6px;">
                                                {{item}}
                                            </span>
                                        </p>
                                        <p v-if="activity.type=='发送短信'" style="margin-bottom:0px;">
                                            <span :style="activity.is_success==1?'color:#0ABF89;':'color:#F56C6C;'">{{activity.is_success==1?'发送成功':'发送失败'}}</span>
                                            {{activity.sms_content}}
                                        </p>
                                        <p class="timeright" style="line-height:24px;margin-bottom:0px;">
                                            <span style="color:#B5B7BF;">操作人：</span>{{activity.admin_name}}
                                        </p>
                                    </el-card>
                                    </el-timeline-item>
                                </el-timeline>
                            </div>
                        </el-card>
                    </div>
                    <!-- 销售记录end -->
                </div>
            </div>
        </el-drawer>
        <!-- 下单 -->
        <el-dialog class="placeorder" title="下单" :visible.sync="orderdialog" :before-close="handleCloseorder" :close-on-click-modal="false" :close-on-press-escape="false" width="1144px">
            <p style="color:#F56C6C;margin-bottom:10px;">若无修改地址，可不操作修改收货人/手机号/地址，系统将自动处理。如需更改，请点击眼睛查看后再修改~</p>
            <el-steps :active="active">
                <el-step title="基本信息" @click.native ="stepClick(1)"></el-step>
                <el-step title="确认下单信息" @click.native ="stepClick(2)"></el-step>
                <el-step title="支付信息" @click.native ="stepClick(3)"></el-step>
            </el-steps>
            <!-- 基本信息 -->
            <div v-if="active==1" style="text-align:right;">
                <el-form :model="orderform" :rules="rules" ref="orderform">
                    <el-row>
                        <el-col :span="4">
                            <div class="grid-content bg-purple-dark decrypt">
                                <el-form-item class="" label="姓名" :label-width="formLabelWidth" prop="consigneeCopy">
                                    <el-input v-model="orderform.consigneeCopy" :disabled="customerDel.customer_type==1?!orderform.changeConsignee:false" autocomplete="off" size="mini" :style="customerDel.customer_type==1?'margin-top:6px;':''">
                                        <template v-if="customerDel.customer_type==1" slot="append">
                                            <i @click="showNameOrderform(orderform)" :class="!orderform.changeConsignee?'iconfont icon-biyanjing':'iconfont icon-yanjing'" style="color:#0d6efd;cursor:pointer;"></i>
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple-dark decrypt">
                                <el-form-item class="" label="手机号" :label-width="formLabelWidth" prop="mobileCopy">
                                    <el-input v-model="orderform.mobileCopy" :disabled="customerDel.customer_type==1?!orderform.changeMobile:false" autocomplete="off" size="mini" :style="customerDel.customer_type==1?'margin-top:6px;':''">
                                        <template v-if="customerDel.customer_type==1" slot="append">
                                            <i @click="showPhoneOrderform(orderform)" :class="!orderform.changeMobile?'iconfont icon-biyanjing':'iconfont icon-yanjing'" style="color:#0d6efd;cursor:pointer;"></i>
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple-dark">
                                <el-form-item label="客户症状" :label-width="formLabelWidth" prop="customer_disease_remark">
                                    <el-input v-model="orderform.customer_disease_remark" autocomplete="off" size="mini"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple-dark">
                                <el-form-item label="年龄段" :label-width="formLabelWidth" prop="customer_age">
                                    <el-select v-model="orderform.customer_age" filterable clearable placeholder="请选择" size="mini">
                                        <el-option v-for="item in ageoptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <!-- <el-col :span="4">
                            <div class="grid-content bg-purple-dark">
                                <el-form-item label="出生日期" :label-width="formLabelWidth" prop="birthday">
                                    <el-date-picker v-model="orderform.birthday" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" size="mini"></el-date-picker>
                                </el-form-item>
                            </div>
                        </el-col> -->
                        <el-col :span="5">
                            <div class="grid-content bg-purple-dark">
                                <el-form-item label="成交来源" :label-width="formLabelWidth" prop="trade_source">
                                    <el-select v-model="orderform.trade_source" filterable clearable placeholder="请选择" size="mini">
                                        <el-option v-for="item in tradeSourceoptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <div class="grid-content bg-purple-dark">
                                <el-form-item label="省" :label-width="formLabelWidth" prop="province">
                                    <el-input v-model="orderform.province" autocomplete="off" size="mini"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="grid-content bg-purple-dark">
                                <el-form-item label="市" :label-width="formLabelWidth" prop="city">
                                    <el-input v-model="orderform.city" autocomplete="off" size="mini"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="grid-content bg-purple-dark">
                                <el-form-item label="区/县" :label-width="formLabelWidth" prop="district">
                                    <el-input v-model="orderform.district" autocomplete="off" size="mini"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="16">
                            <div class="grid-content bg-purple-dark decrypt">
                                <el-form-item class="" label="街道(小区)" label-width="90px" prop="addressCopy">
                                    <el-input v-model="orderform.addressCopy" :disabled="!orderform.changeAddress" autocomplete="off" size="mini" style="margin-top:6px;">
                                        <template slot="append">
                                            <i @click="showAddressOrderform(orderform)" :class="!orderform.changeAddress?'iconfont icon-biyanjing':'iconfont icon-yanjing'" style="color:#0d6efd;cursor:pointer;"></i>
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple-dark">
                                <el-form-item label=" " label-width="20px" style="text-align: left;">
                                    <span style="color:#F56C6C;">省市区请不要填在街道中!!!</span>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="3">
                            <div class="grid-content bg-purple-dark">
                                <el-form-item label=" " label-width="20px" style="text-align: left;">
                                    <el-button @click="getorderIsReachSend()" type="primary" size="mini">检测顺丰到付地址</el-button>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
                <el-button type="primary" plain size="mini" @click.stop="nextClick(2)">下一步</el-button>
            </div>
            <!-- 商品信息 -->
            <div v-if="active==2" style="text-align:right;">
                <el-tabs @tab-click="handleClick" v-model="orderform.itemType">
                    <!-- <el-tab-pane label="商品" name="1"></el-tab-pane> -->
                    <el-tab-pane label="套餐" name="2"></el-tab-pane>
                </el-tabs>
                <div style="text-align:left;">
                    <span>{{orderform.itemType==2?'套餐名称':'商品名称'}}</span>
                    <el-input v-model="ordergoods.name" placeholder="" size="mini" style="width:240px;"></el-input>
                    <el-button type="primary" @click="handleCurrentChange(1)" size="mini">查询</el-button>
                </div>
                <el-table v-if="orderform.itemType==1" :data="goodsCouponList" :cell-style="{padding:'4px 0px'}" :row-style="{height:'38px'}" highlight-current-row max-height="400" style="width: 100%; margin-top: 10px" stripe border>
                    <el-table-column label="商品名称" prop="name" min-width="220" fixed="left"></el-table-column>
                    <el-table-column prop="sku" label="规格" min-width="220">
                        <template slot-scope="scope">
                            <div v-for="(item,index) in scope.row.sku" :key="index">
                                <p :style="index==0?'margin-bottom:0px;':'padding-top:10px;margin-bottom:0px;'">规格：{{item.attr}}</p>
                                <p style="margin-bottom:0px;">价格：{{item.sales_price}}</p>
                                <p style="margin-bottom:0px;">购买数量：
                                    <el-input-number @change="skuChange(scope.$index,index)" v-model="item.num" :min="0" label="描述文字" size="mini"></el-input-number>
                                </p>
                                <p :style="(index+1)==scope.row.sku.length?'margin-bottom:0px;':'border-bottom: 1px solid #ccc;padding-bottom:10px;margin-bottom:0px;'">
                                    购买总价：{{item.totalPrice}}
                                </p>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-table v-if="orderform.itemType==2" :data="goodsCouponList" :cell-style="{padding:'4px 0px'}" :row-style="{height:'38px'}" highlight-current-row max-height="400" style="width: 100%; margin-top: 10px" stripe border>
                    <el-table-column label="套餐名称" prop="package_name" min-width="220" fixed="left">
                        <template slot-scope="scope">
                            <p style="margin-bottom:0px;">{{scope.row.package_name}}</p>
                            <p style="margin-bottom:0px;">价格：{{scope.row.package_price}}</p>
                            <p style="margin-bottom:0px;">购买数量：
                                <el-input-number @change="totalPriceChange(scope.$index)" v-model="scope.row.num" :min="0" label="描述文字" size="mini"></el-input-number>
                            </p>
                            <p style="margin-bottom:0px;">购买总价：{{scope.row.totalPrice}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="goods_package_sku" label="规格" min-width="220">
                        <template slot-scope="scope">
                            <div v-for="(item,index) in scope.row.goods_package_sku" :key="index">
                                <p :style="index==0?'margin-bottom:0px;':'padding-top:10px;margin-bottom:0px;'">规格：{{item.goods_attr}}</p>
                                <p style="margin-bottom:0px;">名称：{{item.goods_name}}</p>
                                <p :style="(index+1)==scope.row.goods_package_sku.length?'margin-bottom:0px;':'border-bottom: 1px solid #ccc;padding-bottom:10px;margin-bottom:0px;'">数量：
                                    <!-- <el-input-number v-model="item.num" :min="0" label="描述文字" size="mini"></el-input-number> -->
                                    {{item.num}}
                                </p>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 分页 -->
                <el-pagination @current-change="handleCurrentChange" :total="total" small layout="prev, pager, next"></el-pagination>
                <el-button type="primary" plain size="mini" @click.stop="nextClick(3)">下一步</el-button>
            </div>
            <!-- 支付信息 -->
            <div v-if="active==3">
                <p style="padding-left:10px;border-left:4px solid #0d6efd;line-height:24px;margin-top:10px;">基本信息</p>
                <el-form :model="orderform" :rules="rules" ref="orderform">
                    <el-row>
                        <el-col :span="4">
                            <div class="grid-content bg-purple-dark decrypt">
                                <el-form-item class="" label="姓名" :label-width="formLabelWidth" prop="consigneeCopy">
                                    <el-input v-model="orderform.consigneeCopy" :disabled="customerDel.customer_type==1?!orderform.changeConsignee:false" autocomplete="off" size="mini" :style="customerDel.customer_type==1?'margin-top:6px;':''">
                                        <template v-if="customerDel.customer_type==1" slot="append">
                                            <i @click="showNameOrderform(orderform)" :class="!orderform.changeConsignee?'iconfont icon-biyanjing':'iconfont icon-yanjing'" style="color:#0d6efd;cursor:pointer;"></i>
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple-dark decrypt">
                                <el-form-item class="" label="手机号" :label-width="formLabelWidth" prop="mobileCopy">
                                    <el-input v-model="orderform.mobileCopy" :disabled="customerDel.customer_type==1?!orderform.changeMobile:false" autocomplete="off" size="mini" :style="customerDel.customer_type==1?'margin-top:6px;':''">
                                        <template v-if="customerDel.customer_type==1" slot="append">
                                            <i @click="showPhoneOrderform(orderform)" :class="!orderform.changeMobile?'iconfont icon-biyanjing':'iconfont icon-yanjing'" style="color:#0d6efd;cursor:pointer;"></i>
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple-dark">
                                <el-form-item label="客户症状" :label-width="formLabelWidth" prop="customer_disease_remark">
                                    <el-input v-model="orderform.customer_disease_remark" autocomplete="off" size="mini"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple-dark">
                                <el-form-item label="年龄段" :label-width="formLabelWidth" prop="customer_age">
                                    <el-select v-model="orderform.customer_age" filterable clearable placeholder="请选择" size="mini">
                                        <el-option v-for="item in ageoptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple-dark">
                                <!-- <el-form-item label="出生日期" :label-width="formLabelWidth" prop="birthday">
                                    <el-date-picker v-model="orderform.birthday" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" size="mini"></el-date-picker>
                                </el-form-item> -->
                                <el-form-item label="成交来源" :label-width="formLabelWidth" prop="trade_source">
                                    <el-select v-model="orderform.trade_source" filterable clearable placeholder="请选择" size="mini">
                                        <el-option v-for="item in tradeSourceoptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <div class="grid-content bg-purple-dark">
                                <el-form-item label="省" :label-width="formLabelWidth" prop="province">
                                    <!-- <el-cascader style="width:100%;" :options="options" v-model="orderform.selectedOptions" @change="addressChoose" size="mini"></el-cascader> -->
                                    <el-input v-model="orderform.province" autocomplete="off" size="mini"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="grid-content bg-purple-dark">
                                <el-form-item label="市" :label-width="formLabelWidth" prop="city">
                                    <el-input v-model="orderform.city" autocomplete="off" size="mini"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="grid-content bg-purple-dark">
                                <el-form-item label="区/县" :label-width="formLabelWidth" prop="district">
                                    <el-input v-model="orderform.district" autocomplete="off" size="mini"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="16">
                            <div class="grid-content bg-purple-dark decrypt">
                                <el-form-item class="" label="街道(小区)" label-width="90px" prop="address">
                                    <el-input v-model="orderform.addressCopy" :disabled="!orderform.changeAddress" autocomplete="off" size="mini" style="margin-top:6px;">
                                        <template slot="append">
                                            <i @click="showAddressOrderform(orderform)" :class="!orderform.changeAddress?'iconfont icon-biyanjing':'iconfont icon-yanjing'" style="color:#0d6efd;cursor:pointer;"></i>
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple-dark">
                            <el-form-item label=" " label-width="20px" style="text-align: left;">
                                <span style="color:#F56C6C;">省市区请不要填在街道中!!!</span>
                            </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
                <p style="padding-left:10px;border-left:4px solid #0d6efd;line-height:24px;">购买商品</p>
                <el-table v-if="orderform.itemType==1" :data="beforegoods" :cell-style="{padding:'4px 0px'}" :row-style="{height:'38px'}" ref="beforegoods" highlight-current-row max-height="400" style="width: 100%; margin-top: 10px" border>
                    <el-table-column label="商品名称" prop="name" min-width="240"></el-table-column>
                    <el-table-column label="商品规格" prop="attr" min-width="240"></el-table-column>
                    <el-table-column label="商品购买数量" prop="num" min-width="120"></el-table-column>
                    <el-table-column label="商品购买总价" prop="totalPrice" min-width="120"></el-table-column>
                </el-table>
                <el-table v-if="orderform.itemType==2" :data="beforegoods" :cell-style="{padding:'4px 0px'}" :row-style="{height:'38px'}" ref="beforegoods1" highlight-current-row max-height="400" style="width: 100%; margin-top: 10px" border>
                    <el-table-column label="套餐名称" prop="name" min-width="240"></el-table-column>
                    <el-table-column label="规格" prop="attr" min-width="240">
                        <template slot-scope="scope">
                            <div v-for="(item,index) in scope.row.attr" :key="index">
                                <p :style="index==0?'margin-bottom:0px;':'padding-top:10px;margin-bottom:0px;'">规格：{{item.goods_attr}}</p>
                                <p style="margin-bottom:0px;">套餐内单价：{{item.price}}</p>
                                <p style="margin-bottom:0px;">套餐内总价格：{{item.total_price}}</p>
                                <p :style="(index+1)==scope.row.attr.length?'margin-bottom:0px;':'border-bottom: 1px solid #ccc;padding-bottom:10px;margin-bottom:0px;'">数量：
                                    {{item.num}}
                                </p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="套餐购买数量" prop="num" min-width="120"></el-table-column><el-table-column label="商品购买总价" prop="totalPrice" min-width="240"></el-table-column>
                    <el-table-column label="商品购买总价" prop="totalPrice" min-width="120"></el-table-column>
                </el-table>
                <el-form>
                </el-form>
                <el-form :model="orderform" :rules="rules" ref="orderform" class="avatar-uploader" style="margin-top:10px;">
                    <el-form-item label="是否添加赠品" prop="is_gift">
                        <el-radio-group @change="changeIs_gift" v-model="orderform.is_gift" size="mini">
                            <el-radio-button :label="1">是</el-radio-button>
                            <el-radio-button :label="0">否</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-show="orderform.is_gift"
                        v-for="(item, index) in orderform.gift_data"
                        :label="'赠品' + (index+1)"
                        :key="item.key"
                        :prop="'gift_data.' + index + '.sku'"
                        :rules="{
                            required: true, message: '请选择赠品', trigger: 'change'
                        }"
                    >
                        <el-select v-model="item.sku" clearable filterable placeholder="请选择" size="mini">
                            <el-option v-for="itemgift in giftGoodsList" :key="itemgift.sku" :label="itemgift.name" :value="itemgift.sku"></el-option>
                        </el-select>
                        <el-input-number v-model="item.num" :min="1" label="描述文字" size="mini"></el-input-number>
                        <el-button v-if="index!=0" @click.prevent="removeDomain(item)" size="mini">删除</el-button>
                        <el-button @click.prevent="addDomain" size="mini">添加赠品</el-button>
                    </el-form-item>
                    <el-form-item :required="true" label="销售标签" prop="tag_list">
                        <el-select v-model="orderform.tag_list" multiple filterable clearable placeholder="请选择" size="mini">
                            <el-option v-for="item in selltagoptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="is_again" label="补发证明" prop="admin_order_img" :rules="{required: true, message: '请上传补发证明', trigger: 'change'}">
                        <el-upload class="" :action="uploadFiles" :on-success="handleAvatarSuccess" :headers="myHeaders" :show-file-list="false">
                            <img v-if="orderform.admin_order_img" :src="orderform.admin_order_img" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <el-input v-model="orderform.remark" type="textarea" :rows="3" placeholder="请输入备注" style="width:90%;" autocomplete="off" size="mini"></el-input>
                    </el-form-item>
                </el-form>
                <p style="padding-left:10px;border-left:4px solid #0d6efd;line-height:24px;margin:16px 0 10px;">
                    优惠券
                    <span style="color:#F56C6C;">优惠券有效期15分钟，超时未支付，优惠券失效，请重新下单</span>
                </p>
                <el-form>
                    <el-form-item label="优惠券" :label-width="formLabelWidth" prop="address">
                        <el-select @change="couponChange" v-model="orderform.coupon_id" clearable filterable placeholder="请选择" size="mini">
                            <el-option v-for="item in couponList" :key="item.id" :label="item.coupon_describe" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <p style="margin-top:10px;">
                    总价：{{goodAlltotalPrice}}
                    <span v-if="orderform.coupon_id" style="margin-left:20px;">优惠券-{{reduce_price}}元</span>
                    <span style="margin-left:20px;color:#0d6efd;">应支付：{{Number(goodAlltotalPrice)-Number(reduce_price)}}</span>
                </p>
                <p v-if="!is_again" style="margin-top:10px;">
                    <span>支付方式：</span>
                    <el-radio-group v-model="orderform.pay_type" size="mini">
                        <el-radio-button :label="1">全额支付</el-radio-button>
                        <el-radio-button :label="0">部分支付</el-radio-button>
                    </el-radio-group>
                </p>
                <p v-if="orderform.pay_type===0" style="margin-top:10px;">
                    <span>支付金额：</span>
                    <el-input-number v-model="orderform.pay_price" :min="0" label="描述文字" size="mini"></el-input-number>
                </p>
                <p v-if="payUrl && !is_again">
                    <span>支付链接：{{payUrl}}</span>
                    <i @click="copyUrl()" class="iconfont icon-fuzhi" style="color:#0d6efd;cursor:pointer;"></i>
                </p>

                <p v-if="OrderInfoCode && !is_again" style="padding-left:10px;border-left:4px solid #0d6efd;line-height:24px;margin-top:10px;">支付二维码</p>
                <p v-if="OrderInfoCode && !is_again">
                    <img style="width:188px;margin-left:20px;" :src="OrderInfoCode"/>
                </p>
                <p v-if="!payUrl&&!OrderInfoCode" style="text-align:right;">
                    <el-button type="primary" plain size="mini" @click.stop="submit('orderform')">提交</el-button>
                </p>
            </div>
        </el-dialog>
        <!-- 标签 -->
        <el-dialog title="标签" :visible.sync="labeldialog" :before-close="handleCloselabel" :close-on-click-modal="false" :close-on-press-escape="false" width="60%">
            <div>
                <div>
                    <el-input @input="tagNmaeChnge()" v-model="tagname"  placeholder="搜索/添加" size="mini" style="width:200px;"></el-input>
                    <el-button @click="gettagList()" type="primary" size="mini">搜索</el-button>
                    <el-button @click="getaddTag()" type="primary" size="mini">添加</el-button>
                </div>
                <div style="margin-top:10px;border-bottom:1px solid #DCDFE6;padding-bottom:10px;">
                    <el-tag @click="item.operate == 1 ? tagAddClick(item) : ''" v-for="(item,index) in tagListShow" :key="index" :type="item.origin==1?'success':'danger'" style="margin-right:8px;margin-bottom:10px;cursor:pointer;">
                        {{item.name}}
                    </el-tag>
                </div>
                <div style="margin-top:10px;">
                    <p>已选标签</p>
                    <el-tag @close="item.operate == 1 ? handleCloseTag(item) : ''" v-for="(item,index) in selectTagList" :key="index" closable style="margin-right:8px;margin-bottom:10px;">
                        {{item.name}}
                    </el-tag>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCloselabel()" size="mini">取 消</el-button>
                <el-button type="primary" @click="getsetTag()" size="mini">绑 定</el-button>
            </div>
        </el-dialog>
        <!-- 销售记录 -->
        <el-dialog title="标签" :visible.sync="tagInfodialog" :before-close="handleCloseTagInfo" :close-on-click-modal="false" :close-on-press-escape="false" width="50%">
            <div class="clearfix" style="width:100%;margin-top:10px;">
                <span v-for="(item,index) in customerDel.tagInfo" :key="index" class="tagStyle" style="margin-bottom:10px;">{{item.name}}</span>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCloseTagInfo()" size="mini">取 消</el-button>
            </div>
        </el-dialog>
        <el-dialog class="dialogstyle" title="呼叫备注" :visible.sync="calldialog" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" width="716px">
            <div slot="title" class="dialogtitle">
                <span style="font-size:18px;color:#303133;">呼叫备注</span>
                <i @click="getcallpackUp()" class="el-icon-arrow-down"></i>
            </div>
            <div class="clearfix">
                <div class="left" style="width:60%;border-right:1px dashed #ccc;padding-bottom:20px;min-height: 330px;">
                    <div class="callright">
                        <!-- <p><span style="color:#f56c6c;">*</span>成交意向度</p>
                        <p style="margin-bottom:10px;">
                            <i @click="rate(n)" v-for="n in 5" :key="n" :class="starClass(n)" style="margin-right:10px;;">
                                <span class="iconfont icon-wuxing" style="cursor:pointer;font-size: 32px;"></span>
                            </i>
                        </p> -->
                        <p><span style="color:#f56c6c;">*</span>结束码</p>
                        <div class="tagListStyle">
                            <span @click="shopTypeClick(index)" v-for="(item,index) in shopTypeoptions" :key="item.code" :style="callform.end_code==item.code?'background:#0d6efd;':'background:#909399;'">
                                {{item.name}}
                            </span>
                        </div>
                        <p>沟通备注</p>
                        <p style="margin-bottom:10px;">
                            <el-input v-model="callform.remark" type="textarea" :rows="3" placeholder="请输入通话备注" style="width:90%;" autocomplete="off" size="mini"></el-input>
                        </p>
                    </div>
                    <div style="width:96%;text-align:right;">
                        <el-button v-if="callLoadingStatus&&userInfo.trList.cno && customerType==1" type="text">通话中</el-button>
                        <el-input v-if="!callStatus&&userInfo.trList.cno && customerType==1" v-model="fenjiCall" placeholder="分机号" type="text" size="mini" style="width:80px;"></el-input>
                        <el-button v-if="!callStatus&&userInfo.trList.cno && customerType==1" @click="clickFenji()" type="primary" size="mini">确定</el-button>
                        <el-button v-if="ringoffBtn&&userInfo.trList.cno && customerType==1" @click="unlink()" type="danger" size="mini">挂断</el-button>
                        <el-button v-if="callSubmit" type="primary" @click="submitcallForm()" size="mini">提 交</el-button>
                    </div>
                </div>
                <div class="left" style="width:40%;">
                    <p style="margin-left:10px;margin-bottom:0;">今日榜单</p>
                    <p v-for="(item,index) in report" :key="index" class="ranking" :style="index+1==1?'background:#D29800;':index+1==2?'background:#00CAD2;':'background:#57D300;'">
                        第{{index+1==1?'一':index+1==2?'二':'三'}}名：{{item.admin_name}}（{{item.department_name}}）
                    </p>
                    <p v-if="admin_ranking>3" style="margin-bottom:0;text-align:center;font-size:12px;">
                        <span class="iconfont icon-24gf-ellipsisVertical"></span>
                    </p>
                    <p v-if="admin_ranking>3" class="ranking">第{{admin_ranking}}名：{{userInfo.name}}（{{department_name}}）</p>
                    <p v-if="admin_ranking!=1" style="margin-bottom:0;text-align:center;color:#D601C0;padding:10px 0;">您距上一名还差 <span style="font-size:18px;color:#f56c6c;">{{diff_money}}</span> 元业绩，加油！</p>
                    <p class="rankingcall" :style="admin_ranking>3?'':'margin:20px auto 4px;'">
                        您今日共呼出通话 <span style="">{{call_num}}</span> 次，成交业绩 {{all_deal_money}} 元
                    </p>
                </div>
            </div>
            <div style="border-top:1px dashed #ccc;padding-top:10px;">
                <p style="margin-bottom:0;">送给：
                    <span style="color:#0d6efd;">{{userInfo.name}}</span>
                </p>
                <p style="font-size:16px;margin-bottom:0;margin-left:24px;">{{oneWord}}</p>
            </div>
        </el-dialog>

        <el-dialog title="新增标签" :visible.sync="callTagdialog" :close-on-click-modal="false" :close-on-press-escape="false" width="400px">
            <el-form :model="callTagform" :rules="callTagrules" ref="callTagform">
                <el-form-item label="标签" label-width="50px">
                    <el-input v-model="callTagform.name" type="text" clearable placeholder="请输入标签名称" size="mini" style="width:100%;"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetcallTagform('callTagform')" size="mini">取 消</el-button>
                <el-button type="primary" @click="submitcallTagform('callTagform')" size="mini">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="发送短信" :visible.sync="sendMessagedialog" :close-on-click-modal="false" :close-on-press-escape="false" width="700px">
            <el-row :gutter="20">
                <el-col :span="8" v-for="(item, index) in textMessages" :key="index" style="margin-bottom:10px;">
                    <el-card :body-style="{ padding: '0px' }">
                        <div style="padding: 14px;">
                            <span>{{item.content}}</span>
                            <div class="bottom clearfix" style="text-align:right;">
                                <el-button @click="submitsendMessage(item.id)" type="text" class="button">发 送</el-button>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
let vm=null;
let timeroutbound=null;
import { customerDetail,customerCallRecord,isWaitToProcess,getMyOrder,orderList,customerHandleLog,getGoodsCouponList,couponListNo,createOrder,getPayQRCode,getOrderInfoCode,getOrderStatus,customerRemarks,customerTrafficCount,sendMessageList,sendShortMessage,tagList,addTag,setTag,customerView,customerPhoneView,orderIsReachSend,trafficTags,callRemarks,trafficInspiring,addTrafficTags,callFile,selltagList,outboundConfig,shopTypeoptions,tradeSource,goodsList,uploadFiles} from '@/api/api.js'
import { mapState } from "vuex";
import {
  provinceAndCityData,
  regionData,
  provinceAndCityDataPlus,
  regionDataPlus,
  CodeToText,
  TextToCode
} from "element-china-area-data";
var statusTime='';
export default {
  components: {
  },
  name: 'CustomerDetail',
  data() {
    return {
      uploadFiles: uploadFiles,
      myHeaders: {
        token: this.$store.state.userInfo.token,
      },
      drawer:true,
      fenjiCall:'',
      customerDel:{
        id:'',
        smsTimes:'',
        maxTimes:'',
        admin_user:'',
        dayCount:'',
        weekCount:'',
        desensitise_name:'',
        nameCopy:'',
        nameChange:false,
        customer_type:'',
        extension_code:'',
        desensitise_phone:'',
        desensitise_virtual_phone:'',
        phone:'',
        phoneCopy:'',
        phoneChange:false,
        gender:'',
        birthday:'',
        origin:'',
        province:'',
        city:'',
        area:'',
        desensitise_street:'',
        streetCopy:'',
        streetChange:false,
        sea_date:'',
        bind_date:'',
        tagInfo:'',
      },
      searchform:{
        status:'',
      },
      dataoptions:[],
      workoptions:[],
      calloptions:[],
      reverse: false,
      activities: [],
      orderdialog:false,
      formLabelWidth: '80px',
      ageoptions:[
        {id:'50岁-60岁',name:'50岁-60岁',},
        {id:'40岁-50岁',name:'40岁-50岁',},
        {id:'30岁-40岁',name:'30岁-40岁',},
        {id:'30岁以下',name:'30岁以下',},
        {id:'60岁以上',name:'60岁以上',},
      ],
      tradeSourceoptions:[],
      active:1,
      isOrderform:false,
      orderform:{
        itemType:'2',
        trade_source:'',
        consignee:'',
        consigneeCopy:'',
        changeConsignee:false,
        mobile:'',
        mobileCopy:'',
        changeMobile:false,
        customer_disease_remark:'',
        customer_age:'',
        birthday:'',
        province:'',
        city:'',
        district:'',
        address:'',
        addressCopy:'',
        changeAddress:false,
        selectedOptions:[],
        pay_type:1,
        pay_price:'',
        tag_list:[],
        remark:'',
        is_gift:'',
        gift_data:[],
        coupon_id:'',
        admin_order_img:'',//补发证明
      },
      options: regionDataPlus,
      rules: {
        trade_source: [
          { required: true, message: '请选择成交来源', trigger: 'change' }
        ],
        consignee: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        consigneeCopy: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[1-9][0-9]\d{8}$/,message: '请输入正确的手机号',trigger: 'blur'}
        ],
        mobileCopy: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[1-9][0-9]\d{8}$/,message: '请输入正确的手机号',trigger: 'blur'}
        ],
        customer_disease_remark: [
          { required: true, message: '请输入客户症状', trigger: 'blur' }
        ],
        customer_age: [
          { required: true, message: '请选择年龄段', trigger: 'change' }
        ],
        selectedOptions: [
          { required: true, message: '请选择省市区', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入街道(小区)', trigger: 'blur' }
        ],
        addressCopy: [
          { required: true, message: '请输入街道(小区)', trigger: 'blur' }
        ],
        pay_price: [
          { required: true, message: '请输入支付金额', trigger: 'change' }
        ],
        tag_list: [
          { required: true, message: '请选择标签', trigger: 'change' }
        ],
        is_gift: [
          { required: true, message: '是否添加赠品', trigger: 'change' }
        ],
      },
      goodsCouponList:[],
      page: 1,
      pageNum: 10,
      total: 0,
      goodsCouponListbefore:[],
      beforegoodsCoupon:[],//回显
      beforegoods:[],//数据
      couponList:[],//优惠券
      goods:[
        {
            spu:'',
            guige:[{mun:'',sku:''},{}],
            coupon_id:''
        },
      ],
      PayQRCode:'',//支付二维码
      OrderInfoCode:'',//订单二维码
      order_id:'',
      tableData:[],
      orderpage: 1,
      orderpageNum: 10,
      ordertotal: 0,
      orderTableData:[],
      orderTablepage: 1,
      orderTablepageNum: 10,
      orderTabletotal: 0,
      remarks:'',//通话备注
      goodAlltotalPrice:'',//下单商品总价
      reduce_price:'',//优惠券优惠金额
      paymode:'1',
      payUrl:'',
      callStatistics:{
        weekCount:'',
        dayCount:'',
      },
      labeldialog:false,
      tagname:'',
      tagList:[],
      tagListShow:[],
      selectTagList:[],
      tagInfodialog:false,
      customerDelTagInfoShow:[],
      stateValue:'',//在线状态
      sellType:'1',
    //   calldialog:true,
      callform:{
        intention:'',
        customer_record_id:'',
        remark:'',
        end_code:'',
      },
      trafficTagsList:[],
      admin_ranking:'',//销售排行
      diff_money:'',
      call_num:'',//呼叫数量
      all_deal_money:'',//销售金额
      department_name:'',
      report:[],//前三名
      oneWord:'',
      callTagdialog:false,
      callTagform:{
        type:2,
        name:'',
      },
      callTagrules:{
        type: [
          { required: true, message: '请选择标签类型', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入标签名称', trigger: 'blur' }
        ],
      },
      selltagoptions:[],
      rating:0,
      codeBtnWord: '发短信', // 发送短信按钮文字
      getCodeBtnDisable:false,
      waitTime:61, // 发送短信按钮失效时间
      outboundvalue:'',
      shopTypeoptions:[],
      giftGoodsList:[],
      ordergoods:{
        name:'',
      },
      sendMessagedialog:false,
      textMessages:[],
    };
  },
  props:['customerId','customerType','is_again'],
  created() {
    this.stateValue=sessionStorage.getItem('stateValue')?parseInt(sessionStorage.getItem('stateValue')):2;
    vm=this;
    this.getcustomerDetail();
    this.getcustomerHandleLog();
    this.getorderList();
    this.getMyOrderList();
    this.getcustomerTrafficCount();
    this.gettagList();
    this.getselltagoptions();

    this.gettrafficTags();
    this.gettrafficInspiring();
    this.getoutboundConfig();
    this.getshopTypeoptions();
    this.getTradeSource();
  },
  computed: {
    ...mapState(['userInfo','callStatus','ringoffBtn','callSubmit','callLoadingStatus','calldialog','calldialogsmall']),
  },
  mounted() {
  },
  methods: {
    //提交补发证明
    handleAvatarSuccess(res, file) {
      this.orderform.admin_order_img =res.data;
    },
    rate(n){
        this.rating = n;
    },
    starClass(n) {
      return {
        fas: n <= this.rating,
        far: n > this.rating
      };
    },
    //拨打
    outcall(){
      if(this.stateValue==1){
        isWaitToProcess({customerId:this.customerDel.id}).then(res=>{
          if(res.data.code==200){
            if(res.data.data.isHave){
                this.$confirm('您有待处理的客户，请先处理！', '提示', {
                    confirmButtonText: '去查看',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$emit('chooseDataDetails');
                }).catch(() => {
                });
            //   this.$message({ duration: 2000,showClose: true,message: '您有待处理的客户，请先处理！',type: 'error' });
            }else{
                let that=this;
                let parmas = {customer_id:this.customerDel.id,type:'2',source:'3',oid:'',};
                customerPhoneView(parmas).then(res => {
                    if(res.data.code==200){
                        that.customerDel.phone=res.data.data.decryptData;
                        customerCallRecord({user_id:that.userInfo.id,phone:that.customerDel.phone,customer_id:that.customerDel.id}).then(response => {
                            if(response.data.code==200){
                                localStorage.setItem('customerID',that.customerDel.id)
                                var phone = that.customerDel.phone;
                                var paramsCall = {};
                                paramsCall.tel = phone;
                                paramsCall.requestUniqueId = response.data.data.customer_record_id;
                                //paramsCall.userField = '{"user_id":6001,"order_id":123}';//参数不会回调
                                // this.calldialog=true;
                                that.$store.dispatch('setcalldialog', true);
                                that.callform.customer_record_id = response.data.data.customer_record_id;
                                ClinkAgent.previewOutcall(paramsCall);
                                that.$store.dispatch('setcallStatus', false);

                                that.outboundvalue--;
                                that.$store.dispatch('setringoffBtn', false);
                                that.$store.dispatch('setcallSubmit', false);
                                timeroutbound = setInterval(function(){
                                    if(that.outboundvalue>1){
                                      that.outboundvalue--;
                                    }else{
                                      clearInterval(timeroutbound)
                                      that.$store.dispatch('setringoffBtn', true);
                                      that.$store.dispatch('setcallSubmit', true);
                                      that.getoutboundConfig();
                                    }
                                },1000);
                            }else{
                                that.$message({ duration: 2000,showClose: true,message: response.data.msg,type: 'error' });
                            }
                        });
                    }else{
                        that.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
                    }
                });
            }
          }else{
            this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
          }
        });
      }else{
        this.$message({ duration: 2000,showClose: true,message: '未上线，请先上线再呼叫！',type: 'error' });
      }
    },
    //分机号
    clickFenji(){
      var params = {digits:this.fenjiCall,direction:'out'};
      ClinkAgent.dtmf(params);
    },
    //挂断
    unlink(){
      ClinkAgent.sipUnlink();
      this.$store.dispatch('setcallStatus', true);
      this.$store.dispatch('setcallLoadingStatus', false);
      this.$store.dispatch('setringoffBtn', false);
      clearInterval(timeroutbound);
      this.getoutboundConfig();
    },
    //发短信
    getsendShortMessage(){
        if(this.customerDel.smsTimes<this.customerDel.maxTimes){
            sendMessageList().then(res => {
                if(res.data.code==200){
                  this.sendMessagedialog=true;
                  this.textMessages=res.data.data;
                }else{
                  this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
                }
            });
        }else{
          this.$message({ duration: 2000,showClose: true,message: '今日次数已达上限',type: 'error' });
        }
    },
    submitsendMessage(id){
            this.$confirm('此操作将给该客户发短信, 是否继续?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
                let parmas = {adminId:this.userInfo.id,customerId:this.customerId,type:id};
                sendShortMessage(parmas).then(res => {
                    if(res.data.code==200){
                        this.$message({ duration: 2000,showClose: true,message: '短信发送成功',type: 'success' });
                        this.getcustomerDetail();
                        this.sendMessagedialog=false;

                        // 因为下面用到了定时器，需要保存this指向
                        let that = this;
                        that.waitTime--;
                        that.getCodeBtnDisable = true;
                        this.codeBtnWord = `${this.waitTime}s 后可重新发送`;
                        let timer = setInterval(function(){
                            if(that.waitTime>1){
                                that.waitTime--;
                                that.codeBtnWord = `${that.waitTime}s 后可重新发送`;
                            }else{
                                clearInterval(timer)
                                that.codeBtnWord = '发短信';
                                that.getCodeBtnDisable = false;
                                that.waitTime = 61;
                            }
                        },1000);
                    }else{
                        this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
                    }
                });
            }).catch(() => {
                this.$message({ duration: 2000,showClose: true,type: 'info',message: '已取消'});
            });
    },
    //客户详情
    getcustomerDetail() {
        customerDetail({customerId:this.customerId}).then(res => {
            if(res.data.code==200){
                this.customerDel.id=res.data.data.id,
                this.customerDel.smsTimes=res.data.data.smsTimes,
                this.customerDel.maxTimes=res.data.data.maxTimes,
                this.customerDel.admin_user=res.data.data.admin_user;
                this.customerDel.dayCount=res.data.data.dayCount;
                this.customerDel.weekCount=res.data.data.weekCount;
                this.customerDel.desensitise_name=res.data.data.desensitise_name;
                this.customerDel.nameCopy=res.data.data.desensitise_name;
                this.customerDel.nameChange=false;
                this.customerDel.customer_type=res.data.data.customer_type;
                this.customerDel.desensitise_phone=res.data.data.desensitise_phone;
                this.customerDel.desensitise_virtual_phone=res.data.data.desensitise_virtual_phone;
                this.customerDel.extension_code=res.data.data.extension_code;
                this.customerDel.phoneCopy=res.data.data.customer_type==1?res.data.data.desensitise_phone:res.data.data.desensitise_virtual_phone;
                this.customerDel.phoneChange=false;
                this.customerDel.effective_date=res.data.data.effective_date;
                // this.customerDel.phone=res.data.data.phone;
                this.customerDel.gender=res.data.data.gender;
                this.customerDel.birthday=res.data.data.birthday;
                this.customerDel.origin=res.data.data.origin;
                this.customerDel.province=res.data.data.province;
                this.customerDel.city=res.data.data.city;
                this.customerDel.area=res.data.data.area;
                this.customerDel.desensitise_street=res.data.data.desensitise_street;
                this.customerDel.streetCopy=res.data.data.desensitise_street;
                this.customerDel.streetChange=false;
                this.customerDel.sea_date=res.data.data.sea_date;
                this.customerDel.bind_date=res.data.data.bind_date;
                this.customerDel.tagInfo=res.data.data.tagInfo;
                if(res.data.data.package_state.includes('prize')){
                  this.orderform.trade_source=1;
                }
                this.customerDelTagInfoShow=this.customerDel.tagInfo.slice(0,3);
                //补发（3999终身治愈套餐）
                if(this.is_again){
                  this.orderClick();
                }
            }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        });
    },
    //客户信息解密
    async showName(data){
      if(!this.customerDel.nameChange){
        let returnData=await this.getcustomerView(this.customerDel.id,1,3,'');
        this.customerDel.nameCopy=returnData?returnData:this.customerDel.desensitise_name;
        this.customerDel.nameChange=returnData?true:false;
      }else{
        this.customerDel.nameCopy=this.customerDel.desensitise_name;
        this.customerDel.nameChange=false;
      }
    },
    async showNameOrderform(data){
      if(!data.changeConsignee){
        let returnData=await this.getcustomerView(this.customerDel.id,1,3,'');
        data.consigneeCopy=returnData?returnData:data.consignee;
        data.changeConsignee=returnData?true:false;
      }else{
        // data.consigneeCopy=data.consignee;
        // data.changeConsignee=false;
      }
    },
    async showPhone(data){
      //客户详情姓名
      if(!this.customerDel.nameChange){
        let returnData=await this.getcustomerView(this.customerDel.id,1,3,'');
        this.customerDel.nameCopy=returnData?returnData:this.customerDel.desensitise_name;
        this.customerDel.nameChange=returnData?true:false;
      }else{
        this.customerDel.nameCopy=this.customerDel.desensitise_name;
        this.customerDel.nameChange=false;
      }
      //客户详情手机号
      if(!this.customerDel.phoneChange){
        let returnData=await this.getcustomerView(this.customerDel.id,2,3,'');
        this.customerDel.phoneCopy=returnData?returnData:this.customerDel.desensitise_phone;
        this.customerDel.phoneChange=returnData?true:false;
      }else{
        this.customerDel.phoneCopy=this.customerDel.customer_type==1?this.customerDel.desensitise_phone:this.customerDel.desensitise_virtual_phone;
        this.customerDel.phoneChange=false;
      }
      //客户详情地址
      if(!this.customerDel.streetChange){
        let returnData=await this.getcustomerView(this.customerDel.id,3,3,'');
        this.customerDel.streetCopy=returnData?returnData:this.customerDel.desensitise_street;
        this.customerDel.streetChange=returnData?true:false;
      }else{
        this.customerDel.streetCopy=this.customerDel.desensitise_street;
        this.customerDel.streetChange=false;
      }
    },
    async showPhoneOrderform(data){
      if(!data.changeMobile){
        let returnData=await this.getcustomerView(this.customerDel.id,2,3,'');
        data.mobileCopy=returnData?returnData:data.mobile;
        data.changeMobile=returnData?true:false;
      }else{
        // data.mobileCopy=data.mobile;
        // data.changeMobile=false;
      }
    },
    async showStreet(data){
      if(!this.customerDel.streetChange){
        let returnData=await this.getcustomerView(this.customerDel.id,3,3,'');
        this.customerDel.streetCopy=returnData?returnData:this.customerDel.desensitise_street;
        this.customerDel.streetChange=returnData?true:false;
      }else{
        this.customerDel.streetCopy=this.customerDel.desensitise_street;
        this.customerDel.streetChange=false;
      }
    },
    async showAddressOrderform(data){
      if(!data.changeAddress){
        let returnData=await this.getcustomerView(this.customerDel.id,3,3,'');
        data.addressCopy=returnData?returnData:data.address;
        data.changeAddress=returnData?true:false;
      }else{
        // data.addressCopy=data.address;
        // data.changeAddress=false;
      }
    },
    copyText(phone){
      let that=this;
      this.$copyText(phone).then(function(){
        that.$message({ duration: 2000,showClose: true,message: '内容已复制到剪切板!',type: 'success' });
      }, function(e) {

      });
    },
    async getcustomerView(customer_id,type,source,oid){
      let decryptData='';
      let parmas = {customer_id,type,source,oid,};
      await customerView(parmas).then(res => {
        if(res.data.code==200){
          decryptData=res.data.data.decryptData;
        }else{
          decryptData='';
          this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
        }
      });
      return decryptData
    },
    async getcustomerPhoneView(){
        let decryptData='';
        let parmas = {customer_id,type,source,oid,};
        await customerPhoneView(parmas).then(res => {
            if(res.data.code==200){
                decryptData=res.data.data.decryptData;
            }else{
                decryptData='';
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        });
        return decryptData
    },
    //客户信息解密end
    //销售记录
    getcustomerHandleLog(){
        customerHandleLog({customerId:this.customerId,type:this.sellType}).then(res => {
            if(res.data.code==200){
                this.activities=res.data.data.data;
            }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        });
    },
    handleClose() {
    //   this.$emit('chooseDataDetails');
      if(this.calldialog==false&&this.calldialogsmall==true){
        this.$store.dispatch('setcalldialogsmall', false);
        this.$store.dispatch('setcalldialog', true);
      }else{
        this.$emit('chooseDataDetails');
      }
    },
    //选择省市区
    addressChoose(value) {
        this.orderform.province = CodeToText[value[0]];
        this.orderform.city = CodeToText[value[1]];
        this.orderform.district = CodeToText[value[2]];
    },
    skuChange(mainIndex,index){
        let totalPrice='';
        totalPrice=Number(this.goodsCouponList[mainIndex].sku[index].sales_price)*Number(this.goodsCouponList[mainIndex].sku[index].num);
        this.goodsCouponList[mainIndex].sku[index].totalPrice=totalPrice;
    },
    totalPriceChange(mainIndex){
        let totalPrice='';
        totalPrice=Number(this.goodsCouponList[mainIndex].package_price)*Number(this.goodsCouponList[mainIndex].num);
        this.goodsCouponList[mainIndex].totalPrice=totalPrice;
    },
    //下单
    orderClick(){
        this.getgoodsList();
        this.orderform.selectedOptions=[];
        this.orderform.consignee=this.customerDel.desensitise_name;
        this.orderform.consigneeCopy=this.customerDel.desensitise_name;
        this.orderform.changeMobile=this.customerDel.customer_type==1?false:true;

        this.orderform.mobile=this.customerDel.desensitise_phone;
        this.orderform.mobileCopy=this.customerDel.customer_type==1?this.customerDel.desensitise_phone:'';
        this.orderform.changeConsignee=this.customerDel.customer_type==1?false:true;

        this.orderform.birthday=this.customerDel.birthday;
        this.orderform.province=this.customerDel.province;
        this.orderform.city=this.customerDel.city;
        this.orderform.district=this.customerDel.area;
        this.orderform.address=this.customerDel.desensitise_street;
        this.orderform.addressCopy=this.customerDel.desensitise_street;
        this.orderform.changeAddress=false;

        // let province = this.customerDel.province;
        // let city = this.customerDel.city=='北京市'||this.customerDel.city=='上海市'||this.customerDel.city=='天津市'||this.customerDel.city=='重庆市'?'市辖区':this.customerDel.city;
        // let area = this.customerDel.area;
        // let arg1 = province?TextToCode[province].code:'';
        // let arg2 = city?TextToCode[province][city].code:'';
        // let arg3 = area?TextToCode[province][city][area].code:'';
        // this.orderform.selectedOptions.push(arg1,arg2,arg3);
        this.orderdialog=true;

        this.goodsCouponList=[];
        this.beforegoodsCoupon=[];
        this.beforegoods=[];
        this.page = 1;
        this.pageNum = 10;
        this.getGoodsCouponListData();
        this.active=1;
        this.goodAlltotalPrice='';
        this.orderform.coupon_id='';
        this.reduce_price='';
        this.payUrl='';
        this.OrderInfoCode='';
        this.PayQRCode='';
    },
    //关闭下单弹框
    handleCloseorder(){
        this.orderdialog=false;
        clearInterval(statusTime);
        if(this.is_again){
          this.$emit('chooseDataDetails');
        }else{
          this.getcustomerDetail();
          this.getMyOrderList();
        }
    },
    //下单下一步
    stepClick(index){
      if(this.active!=index){
        this.nextClick(index)
      }
    },
    nextClick(index){
      if(index==1){
        this.active=index;
      }
      if(index==2){
        if(this.customerDel.customer_type==2&&this.orderform.consigneeCopy==''){
            this.$message({ duration: 2000,showClose: true,message: '请输入姓名',type: 'error' });
            return;
        }
        if(this.customerDel.customer_type==2&&this.orderform.mobileCopy==''){
            this.$message({ duration: 2000,showClose: true,message: '请输入手机号',type: 'error' });
            return;
        }
        if(this.orderform.customer_disease_remark==''){
            this.$message({ duration: 2000,showClose: true,message: '请输入客户症状',type: 'error' });
            return;
        }if(this.orderform.customer_age==''){
            this.$message({ duration: 2000,showClose: true,message: '请选择客户年龄段',type: 'error' });
            return;
        }if(this.orderform.trade_source==''){
            this.$message({ duration: 2000,showClose: true,message: '请选择来源',type: 'error' });
            return;
        }
        this.active=index;
      }
      if(index==3){
        if(this.orderform.itemType==1){
            this.goodsCouponList.forEach(item=>{
                item.sku.forEach(sk=>{
                    if(sk.num!=0){
                        let dataId = this.beforegoods.findIndex((v) => {
                            return v.spu == item.spu && v.sku == sk.sku;
                        });
                        if(dataId==-1){
                            this.beforegoods.push(
                                {
                                    spu:item.spu,
                                    name:item.name,
                                    sku:sk.sku,
                                    num:sk.num,
                                    attr:sk.attr,
                                    totalPrice:sk.totalPrice,
                                }
                            )
                        }else{
                            this.beforegoods[dataId].num=sk.num;
                            this.beforegoods[dataId].totalPrice=sk.totalPrice;
                        }
                    }
                })
            });
        }
        if(this.orderform.itemType==2){
            this.goodsCouponList.forEach(item=>{
                if(item.num!=0){
                    let dataId = this.beforegoods.findIndex((v) => {
                        return v.id == item.id;
                    });
                    if(dataId==-1){
                        this.beforegoods.push(
                            {
                                id:item.id,
                                name:item.package_name,
                                num:item.num,
                                attr:item.goods_package_sku,
                                totalPrice:item.totalPrice,
                            }
                        )
                    }else{
                        this.beforegoods[dataId].num=item.num;
                        this.beforegoods[dataId].totalPrice=item.totalPrice;
                    }
                }
            });
        }
        if(this.beforegoods.length){
            this.goodAlltotalPrice=''
            this.beforegoods.forEach(item=>{
                this.goodAlltotalPrice=Number(this.goodAlltotalPrice)+Number(item.totalPrice);
            });
            this.active=index;
            this.getCouponListData()//优惠券
        }else{
            this.$message({ duration: 2000,showClose: true,message: '请先选择商品购买数量',type: 'error' });
        }
      }
    },
    couponChange(){
        this.reduce_price='';
        this.couponList.forEach(item=>{
            if(item.id==this.orderform.coupon_id){
                this.reduce_price=item.reduce_price;
            }
        })
    },
    handleClick(){
        this.goodsCouponList=[];
        this.beforegoodsCoupon=[];
        this.beforegoods=[];
        this.page = 1;
        this.pageNum = 10;
        this.getGoodsCouponListData();
    },
    //下单商品列表
    getGoodsCouponListData(){
        getGoodsCouponList({itemType:this.orderform.itemType,name:this.ordergoods.name,page:this.page,pageNum:this.pageNum}).then(res => {
            if(res.data.code==200){
                res.data.data.data.forEach(item=>{
                    if(this.orderform.itemType==1){
                        item.sku.forEach(sk=>{
                            sk.totalPrice=''
                        });
                    }
                    if(this.orderform.itemType==2){
                        item.totalPrice=''
                    }
                });
                this.goodsCouponList=res.data.data.data;

                if(this.beforegoodsCoupon.length){
                    if(this.orderform.itemType==1){
                        this.beforegoodsCoupon.forEach(item=>{
                            let dataId = this.goodsCouponList.findIndex((v) => {
                                return v.spu == item.spu;
                            });
                            if(dataId!=-1){
                                this.goodsCouponList[dataId]=item;
                            }
                        });
                    }
                    if(this.orderform.itemType==2){
                        this.beforegoodsCoupon.forEach(item=>{
                            let dataId = this.goodsCouponList.findIndex((v) => {
                                return v.id == item.id;
                            });
                            if(dataId!=-1){
                                this.goodsCouponList[dataId]=item;
                            }
                        });
                    }
                }
                this.total=res.data.data.total;
            }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        });
    },
    //分页
    handleCurrentChange(val){
        this.goodsCouponListbefore=this.goodsCouponList;
        if(this.orderform.itemType==1){
            this.goodsCouponListbefore.forEach(item=>{
                item.sku.forEach(sk=>{
                    if(sk.num!=0){
                        let dataId2 = this.beforegoodsCoupon.findIndex((v) => {
                            return v.spu == item.spu;
                        });
                        if(dataId2==-1){
                            this.beforegoodsCoupon.push(item)
                        }else{
                            this.beforegoodsCoupon[dataId2]=item;
                        }

                        let dataId = this.beforegoods.findIndex((v) => {
                            return v.spu == item.spu && v.sku == sk.sku;
                        });
                        if(dataId==-1){
                            this.beforegoods.push(
                                {
                                    spu:item.spu,
                                    name:item.name,
                                    sku:sk.sku,
                                    num:sk.num,
                                    attr:sk.attr,
                                    totalPrice:sk.totalPrice,
                                }
                            )
                        }else{
                            this.beforegoods[dataId].num=sk.num;
                            this.beforegoods[dataId].totalPrice=sk.totalPrice;
                        }
                    }
                })
            });
        }
        if(this.orderform.itemType==2){
            this.goodsCouponListbefore.forEach(item=>{
                if(item.num!=0){
                    let dataId2 = this.beforegoodsCoupon.findIndex((v) => {
                        return v.id == item.id;
                    });
                    if(dataId2==-1){
                        this.beforegoodsCoupon.push(item)
                    }else{
                        this.beforegoodsCoupon[dataId2]=item;
                    }

                    let dataId = this.beforegoods.findIndex((v) => {
                        return v.id == item.id;
                    });
                    if(dataId==-1){
                        this.beforegoods.push(
                            {
                                id:item.id,
                                name:item.package_name,
                                num:item.num,
                                attr:item.goods_package_sku,
                                totalPrice:item.totalPrice,
                            }
                        )
                    }else{
                        this.beforegoods[dataId].num=item.num;
                        this.beforegoods[dataId].totalPrice=item.totalPrice;
                    }
                }
            });
        }

        this.page = val;
        this.pageNum = 10;
        this.getGoodsCouponListData();
    },
    //优惠券
    getCouponListData(){
        couponListNo({status:2}).then(res => {
            if(res.data.code==200){
                res.data.data.forEach(item=>{
                    item.checked=false;
                })
                this.couponList=res.data.data
            }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        });
    },
    //下单提交
    submit(formName){
        this.$refs[formName].validate((valid) => {
            if (valid) {

                if (this.isOrderform) {
                    return
                }
                this.isOrderform=true;
                if(this.orderform.pay_type===0){
                    if(!this.orderform.pay_price){
                        this.$message({ duration: 2000,showClose: true,message: '请输入支付金额！',type: 'error' });
                        return;
                    }
                    if(this.orderform.pay_price < 0.01){
                        this.$message({ duration: 2000,showClose: true,message: '支付金额不能小于0.01！',type: 'error' });
                        return;
                    }
                }
                let parmas = this.orderform;
                parmas.admin_id= this.userInfo.id;
                parmas.customer_id= this.customerId;
                // parmas.itemType= this.orderform.itemType;
                parmas.discountRemark= "";
                parmas.consignee=this.orderform.consigneeCopy;
                parmas.consignee_change=this.orderform.changeConsignee?1:2;
                parmas.mobile=this.orderform.mobileCopy;
                parmas.mobile_change=this.orderform.changeMobile?1:2;

                // parmas.customer_disease_remark=this.orderform.customer_disease_remark;
                // parmas.customer_age=this.orderform.customer_age;
                // parmas.birthday=this.orderform.birthday;
                // parmas.province=this.orderform.province;
                // parmas.city=this.orderform.city;
                // parmas.district=this.orderform.district;

                parmas.address=this.orderform.addressCopy;
                parmas.address_change=this.orderform.changeAddress?1:2;
                parmas.goods=this.beforegoods;

                if(this.is_again){
                  parmas.admin_order_oid=this.is_again;
                }

                // parmas.coupon_id=this.orderform.coupon_id;
                // parmas.pay_type=this.orderform.pay_type;
                // parmas.pay_price=this.orderform.pay_price;
                // parmas.tag_list=this.orderform.tag_list;
                // parmas.remark=this.orderform.remark;
                // parmas.trade_source=this.orderform.trade_source;
                // parmas.is_gift=this.orderform.is_gift;
                // parmas.gift_data=this.orderform.gift_data;

                this.$confirm((this.orderform.is_gift?'提交的订单有赠品':'提交的订单没有赠品')+', 是否继续?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
                    createOrder(parmas).then(res => {
                        if(res.data.code==200){
                            this.$message({ duration: 2000,showClose: true,message: '下单成功',type: 'success' });
                            this.order_id=res.data.data.order_id;
                            // if(this.paymode==1){//微信内支付
                                this.payUrl=res.data.data.h5_pay_url;
                                this.OrderInfoCode=res.data.data.h5_pay_code;//订单二维码
                                if(this.OrderInfoCode && this.order_id && this.orderdialog && !this.is_again){
                                    let that=this;
                                    statusTime=setInterval(function(){
                                        that.getOrderStatusData(that.order_id)
                                    },3000);
                                }

                                // this.getOrderInfoCodeData(this.order_id)
                            // }
                            // if(this.paymode==2){//二维码支付
                            //     this.getPayQRCodeData(this.order_id);//生成订单支付二维码
                            // }
                            this.isOrderform=false;
                        }else{
                            this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
                            this.isOrderform=false;
                        }
                    });
                }).catch(() => {
                    this.$message({ duration: 2000,showClose: true,type: 'info',message: '已取消'});
                    this.isOrderform=false;
                });


            }
        })
    },
    //生成订单支付二维码
    getPayQRCodeData(order_id){
        getPayQRCode({order_id:order_id}).then(res => {
            if(res.data.code==200){
                this.PayQRCode=res.data.data;
                if(this.PayQRCode && this.order_id && this.orderdialog){
                    let that=this;
                    statusTime=setInterval(function(){
                        that.getOrderStatusData(that.order_id)
                    },3000);
                }
            }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        });
    },
    getOrderInfoCodeData(order_id){
        getOrderInfoCode({order_id:order_id}).then(res => {
            if(res.data.code==200){
                this.OrderInfoCode=res.data.data;
                if(this.OrderInfoCode && this.order_id && this.orderdialog){
                    let that=this;
                    statusTime=setInterval(function(){
                        that.getOrderStatusData(that.order_id)
                    },3000);
                }
            }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        });
    },
    copyUrl(){
      let that=this;
      this.$copyText(this.payUrl).then(function(){
        that.$message({ duration: 2000,showClose: true,message: '内容已复制到剪切板!',type: 'success' });
      }, function(e) {

      });
    },
    //获取订单支付状态
    getOrderStatusData(order_id){
        getOrderStatus({order_id:order_id}).then(res => {
            if(res.data.code==200){
                if(res.data.data.status==1){
                    //已支付
                    this.orderdialog=false;
                    clearInterval(statusTime)
                    this.$message({ duration: 2000,showClose: true,message: '支付成功',type: 'success' });
                }
            }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        });
    },
    //客户购买记录
    getMyOrderList(){
      getMyOrder({customer_id:this.customerId,}).then(res => {
        if(res.data.code==200){
            res.data.data.data.forEach(item => {
              item.consigneeCopy=item.desensitise_consignee;
              item.changeConsignee=false;
              item.mobileCopy=item.customer_type==1?item.desensitise_mobile:item.desensitise_virtual_phone;
              item.changeMobile=false;
              item.addressCopy=item.desensitise_address;
              item.changeAddress=false;
            });
            this.tableData=res.data.data.data;
            this.ordertotal=res.data.data.total;
        }else{
            this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
        }
      })
    },
    //分页
    handleCurrentChangeOrder(val){
        this.orderpage = val;
        this.orderpageNum = 10;
        this.getMyOrderList();
    },
    async showNameOrderData(data,source){
      if(!data.changeConsignee){
        let returnData=await this.getcustomerView(data.customer_id,1,source,data.oid);
        data.consigneeCopy=returnData?returnData:data.desensitise_consignee;
        data.changeConsignee=returnData?true:false;
      }else{
        data.consigneeCopy=data.desensitise_consignee;
        data.changeConsignee=false;
      }
    },
    async showPhoneOrderData(data,source){
      if(!data.changeMobile){
        let returnData=await this.getcustomerView(data.customer_id,2,source,data.oid);
        data.mobileCopy=returnData?returnData:data.desensitise_mobile;
        data.changeMobile=returnData?true:false;
      }else{
        data.mobileCopy=data.customer_type==1?data.desensitise_mobile:data.desensitise_virtual_mobile;
        data.changeMobile=false;
      }
    },
    //客户原订单记录
    getorderList(){
      orderList({customer_id:this.customerId,page:this.orderTablepage,pageNum:this.orderTablepageNum}).then(res => {
        if(res.data.code==200){
            res.data.data.data.forEach(item => {
              item.consigneeCopy=item.desensitise_consignee;
              item.changeConsignee=false;
              item.mobileCopy=item.customer_type==1?item.desensitise_mobile:item.desensitise_virtual_mobile;
              item.changeMobile=false;
              item.addressCopy=item.desensitise_address;
              item.changeAddress=false;
            });
            this.orderTableData=res.data.data.data;

            this.orderTabletotal=res.data.data.total;
        }else{
            this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
        }
      })
    },
    handleChangeOrder(val){
        this.orderTablepage = val;
        this.orderTablepageNum = 10;
        this.getorderList();
    },
    //客户备注提交
    remarksClick(){
        if(!this.remarks){
            this.$message({ duration: 2000,showClose: true,message: '请输入客户备注',type: 'error' });
            return;
        }
        customerRemarks({id:this.customerId,remarks:this.remarks}).then(res => {
            if(res.data.code==200){
                this.$message({ duration: 2000,showClose: true,message: '提交客户备注成功',type: 'success' });
            }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        })
    },
    //客户通话统计
    getcustomerTrafficCount(){
        customerTrafficCount({id:this.customerId}).then(res => {
            if(res.data.code==200){
                this.callStatistics=res.data.data;
            }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        })
    },
    labelClick(){
        this.labeldialog=true;
        this.selectTagList=this.customerDel.tagInfo;
    },
    //标签列表
    gettagList(){
        tagList({name:this.tagname,page:1,pageNum:10000,}).then(res => {
            if(res.data.code==200){
                this.tagList=res.data.data.data;
                this.tagListShow=this.tagList.slice(0,5)
            }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        })
    },
    tagNmaeChnge(){
        if(this.tagname!=''){
            this.tagListShow=this.tagList.filter((tag)=>{
                return tag.name.indexOf(this.tagname) !==-1
            })
        }else{
            this.tagListShow=this.tagList.slice(0,5)
        }
    },
    handleCloselabel(){
        this.labeldialog=false;
    },
    //新增标签
    getaddTag(){
        if(this.tagname==''){
            this.$message({ duration: 2000,showClose: true,message: '请输入标签名称！',type: 'error' });
            return;
        }
        addTag({name:this.tagname}).then(res => {
            if(res.data.code==200){
                this.$message({ duration: 2000,showClose: true,message: '新增标签成功！',type: 'success' });
                this.tagname='';
                this.gettagList();
            }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        })
    },
    tagAddClick(data){
        let dataId =this.selectTagList.findIndex((v) => {return v.id == data.id;});
        if(dataId==-1){
            this.selectTagList.push(data)
        }else{
            this.$message({ duration: 2000,showClose: true,message: '该标签已经选择了！',type: 'error' });
        }
    },
    handleCloseTag(data){
        let dataId =this.selectTagList.findIndex((v) => {return v.id == data.id;});
        this.selectTagList.splice(dataId, 1);
    },
    getsetTag(){
        let tagId=[];
        this.selectTagList.forEach(item=>{
            tagId.push(item.id)
        })
        setTag({customerId:this.customerId,tagId:tagId,}).then(res => {
            if(res.data.code==200){
                this.$message({ duration: 2000,showClose: true,message: '客户绑定标签成功！',type: 'success' });
                this.labeldialog=false;
                this.getcustomerDetail();
            }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        })
    },
    //销售记录更多
    tagInfoMoreClick(){
        this.tagInfodialog=true;
    },
    handleCloseTagInfo(){
        this.tagInfodialog=false;
    },
    sendClick(code){
      window.open('https://www.baidu.com/s?ie=UTF-8&wd='+code, '_blank')
    },

    sellTabClick(){
        this.getcustomerHandleLog();
    },
    getorderIsReachSend(){
        let parmas = {
            province:this.orderform.province,
            city:this.orderform.city,
            district:this.orderform.district,
            address_change:this.orderform.changeAddress?1:2,
            address:this.orderform.addressCopy,
            customer_id:this.customerId,
        };
        orderIsReachSend(parmas).then(res => {
            if(res.data.code==200){
                this.$message({ duration: 2000,showClose: true,message: '到方地址可达',type: 'success' });
            }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        });
    },
    //呼叫备注
    submitcallForm(){
        // this.callform.intention=this.rating;
        // if(this.callform.remark==''){
        //     this.$message({ duration: 2000,showClose: true,message: '请输入备注！',type: 'error' });
        //     return;
        // }
        if(this.callform.end_code==''){
            this.$message({ duration: 2000,showClose: true,message: '请选择结束码！',type: 'error' });
            return;
        }
        let parmas =this.callform;
        callRemarks(parmas).then(res => {
            if(res.data.code==200){
                // this.calldialog=false;
                this.$store.dispatch('setcalldialog', false);
                this.$store.dispatch('setcalldialogsmall', false);
                this.getcustomerHandleLog();
                this.$message({ duration: 2000,showClose: true,message: '呼叫备注提交成功',type: 'success' });
                //挂断
                ClinkAgent.sipUnlink();
                this.$store.dispatch('setcallStatus', true);
                this.$store.dispatch('setcallLoadingStatus', false);
                this.$store.dispatch('setringoffBtn', false);
                this.$store.dispatch('setcallSubmit', false);
                clearInterval(timeroutbound)
                this.getoutboundConfig();
            }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        });
    },
    getcallpackUp(){
        this.$store.dispatch('setcalldialog', false);
        this.$store.dispatch('setcalldialogsmall', true);
    },
    trafficTagClick(index){
        this.trafficTagsList[index].checked=!this.trafficTagsList[index].checked;
        // this.trafficTagsList=this.trafficTagsList;
    },
    shopTypeClick(index){
        this.callform.end_code=this.shopTypeoptions[index].code;
    },
    gettrafficTags(){
        trafficTags().then(res => {
            if(res.data.code==200){
                res.data.data.forEach(item=>{
                    item.checked=false;
                });
                this.trafficTagsList=res.data.data;
            }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        });
    },
    gettrafficInspiring(){
        trafficInspiring().then(res => {
            if(res.data.code==200){
                this.oneWord=res.data.data.oneWord;
                this.call_num=res.data.data.call_num;
                this.admin_ranking=res.data.data.ranking;
                this.report=res.data.data.report;//前三名
                this.diff_money=res.data.data.diff_money;
                this.all_deal_money=res.data.data.all_deal_money;
                this.department_name=res.data.data.department_name;
            }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        });
    },
    //新增标签
    getaddCallTag(){
        this.callTagdialog=true;
    },
    submitcallTagform(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
            let parmas = this.callTagform;
            addTrafficTags(parmas).then(res => {
              if(res.data.code==200){
                this.callTagdialog=false;
                this.$message({ duration: 2000,showClose: true,message: '新增标签成功',type: 'success' });
                this.gettrafficTags();
              }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
              }
            });
        } else {
          return false;
        }
      });
    },
    resetcallTagform(formName){
      this.callTagdialog=false;
      this.$refs[formName].resetFields();
    },
    //查看录音
    getRecording(data,index){
        callFile({call_id:data.call_id}).then(res => {
            if(res.data.code==200){
                let activitie=data;
                activitie.record_url=res.data.data;
                this.activities.splice(index,1,activitie);
            }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        });
    },
    getshopTypeoptions(){
        shopTypeoptions({type:2}).then(res => {
        if(res.data.code==200){
          this.shopTypeoptions=res.data.data;
        }else{
          this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
        }
      })
    },
    getselltagoptions(){
      selltagList({type:1,all:1,}).then(res => {
        if(res.data.code==200){
          this.selltagoptions=res.data.data.data;
        }else{
          this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
        }
      })
    },
    getoutboundConfig(){
      outboundConfig().then(res => {
        if(res.data.code==200){
          this.outboundvalue=Number(res.data.data)+1;
        }else{
          this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
        }
      });
    },
    getTradeSource(){
      tradeSource({status:1}).then(res => {
        if(res.data.code==200){
          this.tradeSourceoptions=res.data.data;
        }else{
          this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
        }
      });
    },

    maskName(str) {
        return str.substr(0,1)+new Array(str.length).join('*') ;
    },

    getgoodsList(){
      let parmas = {status:2,is_gift:1,pageNum:1000};
      goodsList(parmas).then(res => {
        if(res.data.code==200){
            res.data.data.data.forEach(item => {
                item.cover_url=item.cover_url?item.cover_url.split(',')[0]:'';
            });
            this.giftGoodsList=res.data.data.data;
        }else{
            this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
        }
      })
    },
    changeIs_gift(){
        if(this.orderform.is_gift){
            this.orderform.gift_data=[{
                sku:'',
                num:'',
            }]
        }else{
            this.orderform.gift_data=[];
        }
    },
    removeDomain(item) {
        var index = this.orderform.gift_data.indexOf(item)
        if (index !== -1) {
          this.orderform.gift_data.splice(index, 1)
        }
    },
    addDomain() {
        this.orderform.gift_data.push({
            sku:'',
            num:'',
        });
    }
  },
};
</script>

<style scoped>
.cuscard{
    padding:20px;
    border-radius: 4px;
    border: 1px solid #EBEEF5;
}
.label-style{
    color:#B5B7BF;
    margin-right: 14px;
}
.tagStyle{
    float: left;
    background: #C8FFEF;
    color:#0d6efd;
    /* padding:4px 16px; */
    border-radius: 40px;
    margin-right:20px;
    /* margin-top:10px; */
    padding: 2px 12px;
    font-size: 12px;
}
.iconClass{
    position:absolute;
    /* top:20px; */
    top:10px;
    right:20px;
    font-size:24px;
    cursor: pointer;
}
.timeright{
    font-size: 14px;
    color:#070F29;
}
.labelStyle{
    width: 35%;
    padding-left:10px;
    background: #F4FFFC;
    text-align: left;
    margin-right: 10px;
    display: block;
    float: left;
}
.orderStyle .el-pagination{
    margin-top:0px;
}
.payE{
  color:#f56c6c;
}
.payS{
  color:#67c23a;
}
.sendE{
  color:#e6a23c;
}
.sendS{
  color:#fac768;
}
.orderS{
  color:#409eff;
}
.orderE{
  color:#f56c6c;
}
.callright p{
    /* margin-bottom:0; */
    margin-bottom: 4px;
    /* font-size:12px; */
}
.tagListStyle span{
    display: inline-block;
    font-size: 12px;
    color:#fff;
    background: #909399;
    padding: 4px 16px;
    border-radius: 16px;
    margin-right:10px;
    cursor: pointer;
    margin-bottom:5px;
}
.ranking{
    margin-bottom:0;
    width:90%;
    height: 36px;
    line-height:36px;
    color:#fff;
    /* background: #D601C0; */
    background: #409eff;
    border-radius:18px;
    text-align: center;
    margin:4px auto;
}
.rankingcall{
    margin-bottom:0;
    width:90%;
    height: 30px;
    line-height:30px;
    text-align: center;
    margin:4px auto;
    border-radius:4px;
    background:#C4C4C4;
    color:#D601C0;
    font-size:12px;
}
.fas {
  color: #FFD400;
}
.far {
  color: #909399;
}
.dialogtitle{
    position: relative;
}
.dialogtitle i{
    position: absolute;
    top:0;
    right:0;
    font-size: 16px;
    cursor: pointer;
}
</style>
<style>
.div-card .el-card__header{
    padding: 12px 20px
}
.placeorder .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 150px;
}
.placeorder .el-dialog__body{
    padding: 0px 20px 20px;
}
.decrypt .el-input-group__append, .decrypt .el-input-group__prepend{
    padding: 0 2px;
}
.el-dialog__body{
    padding:0px 20px 20px 20px;
}
.dialogstyle .el-dialog{
    background: #E8F2FF;
    border-radius: 8px;
    border: 1px solid #41C4FF;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 250px;
  height: auto;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/customerDetails.vue